<template>
  <div class="page">
    <!-- 联系人列表 -->
    <listCard v-if="contactsListData.length" :data="contactsListData" @clickBtn="clickBtn" @click="clickCard"></listCard>
    <van-divider v-if="!contactsListData.length && !loading" dashed :style="style">暂无数据</van-divider>
    <load :isShow="loading" />
    <section class="bottomWrap">
      <BottomBtn :data="addBtnData" @click="clickBtn"> </BottomBtn>
    </section>
    <van-dialog
      v-model:show="isShowDialog"
      title=""
      :before-close="beforeCloseDialog"
      show-cancel-button
      :confirm-button-text="dialogConfig.confirmButtonText"
      confirm-button-color="#3088c5"
    >
      <div class="dialogContent">
        <h3 class="title" v-if="dialogConfig.title">
          {{ dialogConfig.title }}
        </h3>
        <div v-html="dialogConfig.content"></div>
      </div>
    </van-dialog>
    <van-dialog
      v-model:show="isShowAddDialog"
      :before-close="beforeCloseDialog"
      show-cancel-button
      :confirm-button-text="dialogConfig.confirmButtonText"
      confirm-button-color="#3088c5"
    >
      <div class="addDialogContent">
        <van-field v-model="userName" required label="用户名" placeholder="请输入用户名" :error-message="errorMessage.userName" />
        <van-field v-model="userPhone" required label="手机号" placeholder="请输入手机号" :error-message="errorMessage.userPhone" />
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, nextTick, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import listCard from '@/components/directSales/ContactsBtnListCard.vue'
import load from '@/components/oab/fullLoad.vue'
import BottomBtn from '@/components/order/BottomBtn'
import { getContactsList } from '@/api/directSales'
import { btnCallBack, deleteContactsBtn, updateContactsBtn, addContactsBtn, changeContactsBtn } from '@/util/directSales'
import { showToast } from '@/util/couponCollection'
import _ from 'lodash'
import { mobileValidator, plateValidator } from '@/util/regEx.js'

export default {
  components: {
    listCard,
    load,
    BottomBtn
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      listData: [],
      loading: false,
      isShowDialog: false,
      isShowAddDialog: false,
      userName: '',
      userPhone: '',
      dialogConfig: { content: '', confirmButtonText: '', cancelButtonText: '' },
      style: { color: '#999', borderColor: '#aaa', padding: '0 56px' },
      addBtnData: [{ ...addContactsBtn }],
      errorMessage: { userName: '', userPhone: '' }
    })
    const contactsListData = computed(() => {
      let currentContacts = store.state.currentContacts || {}
      let registerUser = currentContacts.registerUser || null
      let defaultIndex = state.listData.findIndex(item => item.defaultStatusFlag)
      return [{ ...registerUser, register: true, defaultStatusFlag: defaultIndex === -1 ? 1 : 0 }, ...state.listData]
    })
    const getListData = async isShowLoad => {
      try {
        isShowLoad && (state.loading = true)
        let data = await getContactsList()
        state.listData = data
        nextTick(() => {
          checkContactScope(data)
        })
      } catch (e) {
        showToast(e.message, '获取预约列表数据失败')
        state.listData = []
      } finally {
        state.loading = false
        state.userName = ''
        state.userPhone = ''
        state.errorMessage = { userName: '', userPhone: '' }
      }
    }
    onMounted(async () => {
      getListData(true)
    })
    const checkUpdateData = () => {
      // console.log('执行checkUpdateData-----')
      let name = state.userName ? _.trim(state.userName) : ''
      let mobile = state.userPhone ? _.trim(state.userPhone) : ''
      let validator = true
      if (!name) {
        state.errorMessage.userName = '请输入用户名'
        validator = false
      }
      if (!mobile) {
        state.errorMessage.userPhone = '请输入手机号'
        validator = false
      }
      if (mobile && !mobile.match(mobileValidator)) {
        state.errorMessage.userPhone = '请输入正确的手机号'
        validator = false
      }
      if (name.length > 7) {
        name = name.slice(0, 8)
      }
      return !validator ? validator : { name, mobile }
    }
    const clickCard = v => {
      // console.log('clickCard-->', v)
      if (route.query.from === 'confirmOrder') {
        let currentContacts = store.state.currentContacts || {}
        let registerUser = currentContacts.registerUser || null
        let currentUser = { ...v }
        store.commit('SETCURRENTCONTACTS', { registerUser, currentUser })
        router.go(-1)
      }
    }
    // 点击按钮
    const clickBtn = v => {
      let { id, _data } = v
      // console.log('clickBtn-->', v, id, _data)
      if (id === 'switch') {
        const param = { id: _data.id, name: _data.name, mobile: _data.mobile, ...changeContactsBtn.param, defaultStatusFlag: _data.switch }
        state.dialogConfig = Object.assign(
          state.dialogConfig,
          { subParam: { v: { ...v, ...changeContactsBtn }, param }, cb: '' },
          changeContactsBtn.dialogConfig
        )
        state.isShowDialog = true
      }
      if (id === 'delete') {
        const param = { id: _data.id, mobile: _data.mobile, ...deleteContactsBtn.param }
        state.dialogConfig = Object.assign(
          state.dialogConfig,
          { subParam: { v: { ...v, ...deleteContactsBtn }, param }, cb: '' },
          deleteContactsBtn.dialogConfig
        )
        state.isShowDialog = true
      }
      if (id === 'update') {
        const param = { id: _data.id, name: _data.name, mobile: _data.mobile, ...updateContactsBtn.param }
        state.userName = _data.name
        state.userPhone = _data.mobile
        state.dialogConfig = Object.assign(
          state.dialogConfig,
          { subParam: { v: { ...v, ...updateContactsBtn }, param }, cb: checkUpdateData },
          updateContactsBtn.dialogConfig
        )
        state.errorMessage = { userName: '', userPhone: '' }
        nextTick(() => {
          state.isShowAddDialog = true
        })
      }
      if (id === 'add') {
        const param = { ...addContactsBtn.param }
        state.userName = ''
        state.userPhone = ''
        state.dialogConfig = Object.assign(
          state.dialogConfig,
          { subParam: { v: { ...v, ...addContactsBtn }, param }, cb: checkUpdateData },
          addContactsBtn.dialogConfig
        )
        state.errorMessage = { userName: '', userPhone: '' }
        nextTick(() => {
          state.isShowAddDialog = true
        })
      }
    }
    //关闭弹窗
    const beforeCloseDialog = async action => {
      if (action === 'confirm') {
        try {
          let {
            subParam: { v, param },
            cb
          } = state.dialogConfig
          // console.log('beforeCloseDialog--', state.dialogConfig)
          if (cb && typeof cb === 'function') {
            try {
              let res = await cb(param)
              if (res === false) {
                return false
              }
              param = Object.assign(param, res)
              v.fn && (await btnCallBack(v, param))
            } catch (error) {
              return false
            }
          } else {
            v.fn && (await btnCallBack(v, param))
          }
          nextTick(async () => {
            await getListData()
          })
          return true
        } catch (e) {
          showToast(e.message, '操作失败')
        }
      }
      if (action === 'cancel') {
        state.dialogConfig.subParam = {}
        await getListData()
        return true
      }
    }
    const checkContactScope = data => {
      let listData = data || state.listData
      let currentContacts = store.state.currentContacts || {}
      let registerUser = currentContacts.registerUser || null
      let currentUser = currentContacts.currentUser || null
      let defaultContact = listData.find(item => item.defaultStatusFlag)
      if (currentUser?.id) {
        const isScope = listData.find(item => item.id === currentUser.id)
        if (isScope) {
          return
        }
      }
      currentUser = defaultContact || registerUser
      store.commit('SETCURRENTCONTACTS', { registerUser, currentUser: { ...currentUser } })
    }
    return {
      ...toRefs(state),
      clickBtn,
      clickCard,
      beforeCloseDialog,
      contactsListData
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  padding-top: 10px;
  padding-bottom: calc(116px + constant(safe-area-inset-bottom));
  padding-bottom: calc(116px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  :deep(.noBorder) {
    border: none !important;
  }
  :deep(.van-popup.van-dialog button) {
    background: #fff;
    color: #666;
  }
  :deep(.dialogContent) {
    padding: 38px 10px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
  }
  :deep(.addDialogContent) {
    padding: 38px 10px 0px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
  }
}
.bottomWrap {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  padding: 16px 20px 30px;
  background-color: #f5f5f5;
  .btnCompnentBox + .btnCompnentBox {
    margin-top: 8px;
  }
  .van-badge__wrapper {
    margin-right: 10px;
    vertical-align: middle;
  }
  .span {
    vertical-align: middle;
  }
}
</style>
